export default __webpack_public_path__ + "static/media/75g.03e41ffe.svg";